module.exports = __webpack_public_path__ + "img/plant.4d29d17d.png";